// Which build this is (#459): the git commit `vite.config.js` stamped into the
// bundle as `__APP_VERSION__`, so a burst of `client.error` after a deploy can
// be pinned to the deploy that caused it (docs/operations.md §5).
//
// Read through `typeof`, because under Jest nothing defines it — the same
// guard `__APP_BASE_PATH__` gets in App.jsx — and a bare reference would be a
// ReferenceError there.
export const APP_VERSION = typeof __APP_VERSION__ === 'string' && __APP_VERSION__ ? __APP_VERSION__ : 'dev';
